import ApiBase from '../ApiBase';

class SurveyAPI extends ApiBase {
    /**
     * @method checkSubmission
     * @returns {Promise<*>}
     * @param data
     */
    checkSubmission = (data) => {
        return this.get('survey/check-submission', data);
    };

    /**
     * @method store
     * @param {object} data
     * @returns {Promise<*>}
     */
    store = (data) => {
        return this.post('survey', data);
    };
}

export default new SurveyAPI();
